<template>
    <div class="sheetLogs" style="padding: 0px">
        <iframe
            v-if="currentIframe"
            class="sheetLogs-content"
            :src="currentUrl"
            frameborder="0"
            allowtransparency="true"
            :title="currentIframe.name"
        ></iframe>
    </div>
</template>

<script>

    export default {
        name: "sheetIframe",
        components: {},
        props: {
            dataId: String,
            modKey: String,
            currentIframe: {
                type: Object,
                default: () => {
                    return {};
                }
            }
        },
        computed: {
            currentUrl () {
                return this.currentIframe.url + "?id=" + this.dataId;
            }
        },
        data () {
            return {};
        },
        created () {},
        methods: {}
    };
</script>



// WEBPACK FOOTER //
// src/views/menu/sheet/attach/sheetIframe.vue